export const conferences = [
    {
        "id": 0,
        "Title": "Dr. R.H.N Shenoi Memorial Surgical Workshop & Surgical Skills Course",
        "MainImage": "/static/coe-dubai-banner.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/coe-dubai-banner.webp"
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "The hard work and achievements in the field of Endohernia training has been evaluated by the national association of hernia, the Hernia Society of India, which recognized B.E.S.T. Institute & Research Centre as “Centre of Excellence in Endohernia surgery”. Later, Asia Pacific Hernia Society also recognized the Institute as “Centre of Excellence” at its annual conference at Dubai. This is the second Institute in the country to receive such a honor."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/coe-dubai-g1-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/coe-dubai-g1-2.webp",
                        "description": ""
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 1,
        "Title": "HERNIA ESSENTIALS",
        "MainImage": "/static/cw-2-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw-2-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 12th & 13th October 2018 Venue: Ramaiah Advanced Learning Centre",
                "text": "Hernia Essentials is an APHS accredited Hernia training course based on current international guidelines on hernia management. This is a prologue to an “Internationally accredited Fellowship in Hernia”. This program is accredited and endorsed by Royal College of Surgeons, Edinburg. This Diploma in Hernia Essentials contains 3 modules, Hernia Essentials Basics, Hernia Essentials Practical and Hernia Essentials Fellowship. The venue for the event was “Advanced Learning Center, M. S. Ramaiah Medical College campus. This was a two day program consisting of CMEs, Hernia quiz, Live operative workshop and Cadaveric hands on training. Faculties for the course were Prof. Sathien Tumtavitikul (Thailand), Prof Barlian Sutedja (Indonesia), Dr Rajesh Khullar, Dr M.Ramesh, Dr Anil Sharma, Dr Deepraj Bhandarkar, Dr Uday Muddebihal, Dr Lakshmi Kona and Dr.Ganesh Shenoy. On the 12 th October was session of “Hernia Basics” which included didactic sessions from internationally renowned faculty. The Hernia Basics was attended by 30 surgeons. On the 13th there was an operative workshop followed by Cadaveric Hands-on course. There were 8 stations for the hands on cadaveric course, with 2 candidates per station. There were 14 surgeons for the cadaveric hands on training with 4 international candidates. Cadaveric hands on training was on Laparoscopic TAPP, TEP and IPOM plus repair. In the live Operative workshop, Laparoscopic Bilateral TAPP mesh repair, Bilateral Laparoscopic TEP Mesh repair, Laparoscopic IPOM Plus repair and Lichtenstein repair were demonstrated. Total of 3 candidates from the country completed Hernia Essentials Fellowship program from BEST Institute and Research Center after training for 15 days in this “APHS recognised Center of Excellence” Institute."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw2-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw2-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw2-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw2-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw2-g-5.webp",
                        "description": ""
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 2,
        "Title": "AICOG 2019 - THE INSIDE STORY",
        "MainImage": "/static/cw3-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw3-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 8th January 2019 Venue: Conference Venue- Hotel Lalith Ashok Operative Venue- A.V. Hospital, Basavanagudi",
                "text": "A.V. Hospital has been involved in the conduct of various academic activities in the field of laparoscopic and hysteroscopic surgery. We were happy and grateful for having been given the opportunity of hosting the Pre-congress Hysteroscopy workshop for AICOG 2019. Patients who required hysteroscopic procedure were selected by conducting free health camps at rural areas, meeting doctors at urban health centers and peripheral health centers to benefit the lower socio-economic class. The program was inuagurated by Dr. M. Arundhathi (presently the senior-most gynaecologist of Karnataka State) and Dr. R.S.K. Murthy, the founders of A.V. Hospital, along with Dr. P.M. Chandrashekar, senior anaesthesiologist and operative faculty. Simultaneously a brief inauguration was organized at the Ball Room of Hotel Lalith Ashok. There was no delay or interruption throughout the workshop right from 9 am to 7 pm. Both the teams at A.V. Hospital and Hotel Lalith Ashok made sure there was very good interaction and every aspect of hysteroscopy was demonstrated and discussed throughout the day. Delegates from various parts of India and abroad enjoyed the live operative demonstration at Grand Ball room at Hotel Lalit Ashok. A video book consisting all types of hysteroscopic surgeries was distributed to all the delegates."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw3-g1-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw3-g1-2.webp",
                        "description": ""
                    }
                ],
                "description": "The program was inuagurated by Dr. M. Arundhathi (presently the senior-most gynaecologist of Karnataka State) and Dr. R.S.K. Murthy, the founders of A.V. Hospital, along with Dr. P.M. Chandrashekar, senior anaesthesiologist and operative faculty. Simultaneously a brief inauguration was organized at the Ball Room of Hotel Lalith Ashok."
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "A total of 23 interesting cases were demonstrated during the workshop. This was done in four sessions: Uterine Anamolies, Myometrial defects, Infertility procedures, Uterus saving procedures The vast array of cases performed by various faculty included septal resection, Asherman’s syndrome, submucous myomectomy, TCRE, targeted endometrial biopsy, tubal cannulation, IUD removal, shaving of internal os, etc. A video book consisting all types of hysteroscopic surgeries was distributed to all the delegates."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw3-g2-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw3-g2-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw3-g2-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw3-g2-4.webp",
                        "description": ""
                    }
                ],
                "description": ""
            },
            {
                'Type': 'Text',
                'Header': '',
                'text': '<ul><li>Dr. Osama Shawki -‘Fantastic show, the variety of uterine septums arranged was extraordinary’</li> <li>Dr. MilindTelang- ‘Excellent case collection, very good infrastructure’</li> <li>Dr. Krishna Kumar -‘Extremely well organized workshop at national level’</li> <li>Dr. Malavika Mishra – ‘Very good collection of cases and excellent management of workshop’</li> <li>Dr. SudhaTandon – ‘Very good organizing team’</li> <li>Dr. Parul Kotdawala – ‘Excellent set-up and co-ordination’</li></ul>'
            }
        ]
    },
    {
        "id": 3,
        "Title": "IRCAD Laparoscopic General Surgery Intensive Course",
        "MainImage": "/static/cw4-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw4-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:7th, 8th, December 2019 Venue: Bangalore Medical College & Research Institute Auditorium",
                "text": "This year, Professor RHN Shenoi Memorial workshop & surgical skills course was organised in Bangalore Medical College by Bangalore Endoscopic Surgery Training Institute & Research Centre and Bangalore Surgical Trust in association with the Department of Surgery, Bangalore Medical College, on the 7th and 8th of December 2019. This programme included Live Operative workshop on 7th and Laparoscopic surgery skills course on 8 th December 2019. The Surgical Workshop was a full day programme starting from 9:00AM to 6:00 PM. The live laparoscopic surgeries were beamed from various Center of Excellence in the country to the venue Dr. Basavarajendra Alumni Auditorium , Bangalore Medical College. Various basic and advanced surgeries were demonstrated, some of them being live and some being virtual. Senior accomplished surgeons from across the country demonstrated surgeries using Video conferencing technology. The faculty included Dr.Aravind Kumar, Dr. Randeep Wadhawan and Dr. Pradeep Jain from Delhi , Dr Abhay Dalvi and Dr Sameer Rege from Mumbai ,Dr Sunil Popat from Ahmedabad and Dr. Vijay Kumar from Mangalore. Faculty from Bangalore for this live and virtual surgery were Dr. K.V. Ashok Kumar, Dr. K Lakshman, Dr. Anjanappa, Dr. KS Gopinath, Dr CS Rajan Dr Arun Kumar, Dr Yella Reddy, Dr. Satish Kumar, Dr. Govind Nandakumar, Dr. Shabeer Ahmed, Dr. Noorul Hassan, Dr. Chandramouli, Dr. Rajshekar Babu G, Dr.Ravishankar Bhat , Dr. Nanda Rajaneesh, Dr. Srinivas N.M , Dr.Kalaivani, Dr. Vijayalakshmi, Dr. Prakash, Dr. Aravind Gubbi, Dr. MR Sreevathsa, Dr. Anil, Dr.Harindranath HR, Dr K Sheshagiri Rao, Dr Sudharshan, Dr.Rajshekar Reddy, Dr. Tulip, Dr Ramesh Reddy G, Dr CR Chhallani, Dr Shivaswamy, Dr Ganesh Shenoy , DrV. Shashikala, Dr. Bhanuprakash, Dr.M.Ramesh, Dr.Ramesh Thambat, Dr.Kemparaju KR, Dr.Ajitha MB and Dr.HV Shivaram. The surgeries demonstrated were Laparoscopic Hellers Cardiomyotomy & Toupet fundoplication, Laparoscopic Nissens fundoplication, Lapaparoscopic adrenalectomy, Trans-oral thyroidectomy, Hemiglossectomy with Radical neck dissection, Laparoscopic Abdomino Perineal resection, Laparoscopic right hemicolectomy"
            },
            {
                "Type": "BannerImage",
                "url": "/static/cw4-banner-2.webp"
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "Trans-oral thyroidectomy, Hemiglossectomy with Radical neck dissection, Laparoscopic Abdomino Perineal resection, Laparoscopic right hemicolectomy, laparoscopic TAPP Mesh Repair for Inguinal hernia, Laparoscopic Roux -en -y Gastric Bypass & Laparoscopic ETEP mesh repair for ventral hernia. There was simultaneous presentation on 2 screens with audio shifting from one screen to the other. Senior surgeons from the city chaired the sessions and moderated with active participation. Dr. B.M. Agadi, Medical Director of Agadi Hospital and Secretary, Bangalore Surgical Trust, was awarded the “Life Time Achievement Award” in recognition of his services, by B.E.S.T Institute & Research Centre. On the 8th of December we had 108 post graduate students registered for the surgical skills course, which was organised at the Surgical Skills Centre of Bangalore Medical College. They were trained in intestinal suturing, vascular suturing, extra corporeal knot applications, stapling techniques, use of energy sources, laparoscopic suturing & laparoscopic intra corporeal knotting. Senior professors and consultants who were faculty for the various training sessions include Dr.M.Ramesh, Dr.Vasudeva Rao, Dr Sreevathsa, Dr. Srinivas Murthy, Dr Muralidhar, Dr.BS Ramesh, Dr.Ganesh Shenoy,Dr Mallikarjun and Dr Harinath."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw4-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-5.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-6.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-7.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-8.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-9.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-10.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw4-g-11.webp",
                        "description": ""
                    }
                ],
                "description": ""
            },
        ]
    },
    {
        "id": 4,
        "Title": "HERNIA MASTER CLASS - 2018",
        "MainImage": "/static/cw5-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw5-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:24th March 2018 Venue: PMSSY Auditorium, BMC Super speciality Hospital and Research Institute, Victoria Hospital campus, Bangalore",
                "text": "This was a single theme, single day CME and live operative workshop organized by Best Institute and Research Center in association with Bangalore Medical College and Research Institute and A.V.Hospital, Bangalore. The venue was at PMSSY Auditorium, BMC Super speciality Hospital and Research Institute, Victoria Hospital campus, Bangalore. Dr. M. Ramesh,Director, Best Institute and Research Center and Medical Director of A. V Hospital was the Organising Chairman and Dr. Seshagiri Rao ,Prof and Head, Department of General Surgery BMCRI was the Co-Organising chairman. Dr Tulip, Medical Director of Dr. Tulips Obesity and Diabetic Surgery Center was the Organising Secretary and Dr. Ganesh Shenoy from A. V. Hospital was the Joint Organising Secretary and Program Co-ordinator. This conference was endorsed by Hernia Society of India and KSCASI. Dr.T. Sivakumar ,Vice president, South zone, Hernia Society of India and Dr. Narayana Hebsur, Secretary KSC ASI graced the occasion. Dr. M. K. Ramesh Vice Chancellor, RGUHS was the Chief Guest for the inaugural ceremony. This event included didactic sessions, debates, panel discussion and live operative HERNIA MASTER CLASS – 2018 workshop on Inguinal and Ventral hernias. Dr C.S.Rajan , Dr Ashok Nayak ,Dr Challani,Dr.H.V.Shivaram, Dr Durganna,Dr. Sheshagiri Rao , Dr.B.S.Ramesh, Dr Arun Kumar, Dr Madan Mariappa, Dr Sudharshan, Dr Subramanya, Dr Ramesh Reddy , Dr Mallikarjuna, Dr. M.N, Dr Abdul Razack, Dr Premkumar and Dr Sreekar Pai were faculty for the C.M.E The live operative workshop was telecasted from AV Hospital to the venue. A. V. Hospital is the first and only hospital in South India to be recognized by HSI as “Center of Excellence” in Endohernia Surgery Training The live operative workshop included Laparoscopic TEP, TAPP, E-TEP for Inguinal hernia, Laparoscopic IPOM Plus repair for Umbilical Hernia and Laparoscopic Nissens Fundoplication for Hiatus Hernia. This is the first time in our state conference that Laparoscopic E-TEP mesh repair for Inguinoscrotal hernia was demonstrated in a live operative workshop. Dr.M.Ramesh ,Dr.Tulip , Dr T.Sivakumar and Dr Ganesh Shenoy were the operating faculty. It was attended by 132 delegates from all across the state of Karnataka and neighboring states. This conference was granted 2 credit hours by Karnataka Medical Counsil."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw5-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw5-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw5-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw5-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw5-g-5.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw5-g-6.webp",
                        "description": ""
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 5,
        "Title": "DR.R.H.N.SHENOI MEMORIAL LIVE OPERATIVE WORKSHOPAND DR.HANUMAIAH MEMORIAL CME PROGRAMME",
        "MainImage": "/static/cw6-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw6-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:19th, 20th, 21st, 22nd, 23rd Nov 2018 Venue: M.S.Ramaih Medical College Auditorium",
                "text": "Dr.R.H.N.SHENOI Memorial Live Operative workshop and Dr.Hanumaiah Memorial Continuous Surgical Educational Programme was conducted from 19th Nov-23rd Nov 2018. The venue was at M.S.Ramaih Medical College Auditorium. This was conducted by Bangalore Surgical Trust in association with Surgical Society of Bangalore. Dr.M.Ramesh from A.V.Hospital was the Chief co-ordinator for the Live Operative workshop. Dr.Ganesh Shenoy from A.V.Hospital demonstrated laparoscopic TEP Mesh repair for inguinal hernia during the live operative workshop. The Live Operative workshop was relayed from renowned institutes across the country. "
            },
            {
                "Type": "BannerImage",
                "url": "/static/cw6-banner-1.webp"
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "19th : Basic Laparoscopic Surgery -M.S.Ramaiah Medical College, Bangalore</br>20th : Laparoscopic Colorectal Surgery – Kaizen Hospital, Ahmedabad</br>21st : Laparosopic Bariatric / Metabolic Surgery- Dr.Tulips Obesity and Diabetes SurgeryCenter, Bangalore</br>22nd : Therapeutic Endoscopy- Asian Institute of Gastroenterology, Hyderabad</br>23rd : Surgical Oncology – M.S.Ramaiah Medical College, Bangalore Around 450 Surgeons and postgraduates across the country attended this meeting. The live operative workshop was well appreciated by the participants."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw6-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw6-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw6-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw6-g-4.webp",
                        "description": ""
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 6,
        "Title": "SURGIQUEST 2016 & PROF. R.H.N. SHENOI MEMORIAL SURGICALWORKSHOP (GAINING THE EDGE)",
        "MainImage": "/static/cw7-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw7-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:8th, 9th, 10th July 2016 Venue: Vijaynagar Institute of Medical Sciences, Ballary",
                "text": "This 3 day conference was organised by BEST Institute and Research Centre, VIMS Ballari and Bangalore Surgical Trust. Modern surgery is effort-intensive and technology dependent.To deliver the promise of effective surgery, the theme of this conference was on Safe Surgical Skills with focus on “Gaining the Edge”over Surgery. The Chief Patron for this conference was Dr V. Srinivasa, Director,VIMS, Ballari. Dr Vidyadhar A Kinhal was the Organising Chairman, Dr Govindaraj E was the Organising Secretary and Dr.M.Ramesh was the Chief Co-ordinator. The first day of this conference included live operative workshop from VIMS Ballari and various “Centre of Excellence” across the globe. This theme based live transmission of laparoscopic surgeries were from Thailand, Singapore,Taiwan, Delhi, Kochin and Bangalore. All the laparoscopic surgeries performed were beamed live to the conference venue. The International faculty for this theme based live operative workshop were Dr Shankar Pashupathy(Singapore), Dr Suthep Udosawaengsup( Bangkok), Dr Li Weijei, (Taiwan) and Dr.Jaideepraj Rao( Singapore). The National faculty included Dr Arun Prasad( Delhi), Dr Dr Prakash K(Kochin), Dr Aashish Shah( Bangalore), Dr Tulip ( Bangalore ), and Dr Ganesh Shenoy ( Bangalore). The Laparoscopic Surgeies demonstrated were Banded Sleeve Gastrectomy, IPOM Plus repair, Bilateral herniotomy, TEP Mesh Repair, D2 Gastrectomy and Low Anterior Resection. Robotic surgery demonstrated was RYGB. This was attended by 220 delegates. This live operative workshop also included Open Oncological surgeries like Radical Neck Dissection and Modified Radical Mastectomy. Dr Vijay Kumar Vice Chancellor, Yenepoya University, Mangalore and Dr K.S.Gopinath, HCG Centre, Bangalore were the chief operating faculty. The second day and first half of third day of the conference included Symposium, Guest Lectures, Panel discussions, Medical writing course, Poster presentations and Master Quiz. The later half of third day was Laparoscopic surgical skills course on BEST institute designed endotrainers. This was attended by 56 delegates. "
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw7-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-4.webp",
                        "description": "Inaugural Function Dr. C.S. Rajan, Dr. Vidhyadhar, Dr. Durganna"
                    },
                    {
                        "imageUrl": "/static/cw7-g-5.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-6.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-7.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-8.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-9.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-10.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-11.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-12.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-13.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-14.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-15.webp",
                        "description": "Lifetime achievement Award to Dr.Gangal"
                    },
                    {
                        "imageUrl": "/static/cw7-g-16.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw7-g-17.webp",
                        "description": "National Professional Excellence Award to Dr.G.V Rao"
                    },
                    {
                        "imageUrl": "/static/cw7-g-18.webp",
                        "description": "State Professional Excellence Award to Dr. Kerudi"
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 7,
        "Title": "DR. R.H.N. SHENOI MEMORIAL SURGICAL WORKSHOP & CME",
        "MainImage": "/static/cw8-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw8-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:14th, 15th, 16th August 2015 Conference Venue: Dr.T.B. Basavarajendra Auditorium, Bangalore Medical College & Research Institute, Operative Venue: Vikram Hospital",
                "text": "This was the first ever R.H.N.Shenoi Memorial Surgical Workshop and C.M.E. This was organised by BEST Institute and Research Centre and Bangalore Surgical Trust in association with Surgical Society of Bangalore and Vikram Hospitals. The 1st workshop and C.M.E was held at Bangalore Medical College and Research Institute, where Dr. Shenoi retired as Dean of the institute after rendering his services in all the 4 government colleges of Karnataka where he taught thousands of students in the field of surgery. Dr. M. Ramesh was the Organising Chairman, Dr Tulip was the Organising Secretary, Dr Ganesh Shenoy and Dr. M.K.Ramesh were the Organising Joint Secretaries for this conference. This conference included Preconference Laparoscopic surgery skills course on the 14th, Live Operative Workshop on 14th and first half of 16th, CME on Medical Writing course on the latter half of 16th August 2020. The Laparoscopic skills course was conducted at “Clinical Skills Center “Bangalore Medical College Campus. This was attended by 120 delegates. Expert faculty from B.E.S.T. Institute and Research Center were involved in imparting and optimise training difficult skills of laparoscopic surgery in a short time. The exercises included basic endotrainer exercises to develop hand-eye co ordination to advanced skills of endosuturing and knotting on animal tissues. There were 24 BEST Institute designed endotrainers installed with delegates divided into 5 batches. The Live Operative workshop was held at Vikram Hospital, the surgeries were beamed to T.B. Basavarajendra auditorium. Three Operating theatres were used to demonstrate the surgeries. The live surgery included demonstration of both Open and Laparoscopic surgeries. The open surgeries which were demonstrated were Inguinal Herniorraphy, Inguinal Hernioplasty, Rives Stoppas mesh repair for Incisional hernia, RFA for varicose veins and Doppler guided arterial ligation of haemorrhoids. The laparoscopic surgeries included basic procedures like Laparoscopic Cholecystectomy, advanced procedures like Laparoscopic TEP and TAPP Mesh repairs for Inguinal hernias, IPOM Plus repairs for Incisional hernias, Laparoscopic Nissen’s Fundoplication, Laparoscopic Heller’s Cardiomyotomy , Laparoscopic Roux-en-Y Gastric bypass ,SILS Cholecystectomy and Minilap Cholecystectomy. Eminent surgeons from all over the country were faculty for this esteemed live operative workshop."
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "Eminent surgeons from all over the country were faculty for this esteemed live operative workshop. The surgeries were demonstrated using latest methodology, devices and innovations with emphasis on basic principles of surgical techniques. Senior surgeons from across the state chaired the sessions adding value by discussing about the surgeries thread bare. The ultimate finale of the programme was a CME programme later half of the day on 16th August. One of the most popular courses of the country on “ Medical Writing “ was organised as a symposium by National experts who discussed in detail about practical aspects of medical publishing. This Live Operative Workshop and CME was granted 6 credit hours by Karnataka Medical Council. This was attended by 450 delegates. Dr.K.S.Ravindranath , Vice Chancellor of Rajiv Gandhi University of Health Sciences was the chief guest for the inaugural function. Dr Padmanabhan, INSA Senior Scientist, Indian Institute of Science Bangalore, Senior Science and Innovative advisor, BIRAC, DBT, New Delhi was bestowed with “Life Time Achievement Award” by B.E.S.T. Institute and Research Centre. Dr.C.R. Ballal, renowned professor of surgery from Mangalore was awarded Professonal Excellence Award by B.E.S.T. Institute."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw8-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw8-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw8-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw8-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw8-g-5.webp",
                        "description": ""
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 8,
        "Title": "INTERNATIONAL CONCLAVE ON ADVANCED BARIATRIC & METABOLIC SURGERY – CONFERENCE & WORKSHOP (AN IAGES EVENT)",
        "MainImage": "/static/cw9-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw9-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:21st , 22nd September 2013 Conference Venue: Hotel Marriott, Operative Venue: Vikram Hospital",
                "text": "The faculty included Dr. John Thanakumar who was a pioneer of advanced laparoscopic surgery in India and Dr. Nagabhushan, an accomplished urologist from USA. The uniqueness of this conference was initiating a technology conference for the first time in the country for surgeons. Video streaming was done to 8 different cities for doctors to watch the conference live in their respective auditoriums in difference medical colleges and major hospitals. This is by far the first time video streaming technology was used in the country.More than 300 surgeons and gynaecologists registered as delegates for this pioneering conference and workshop at Bangalore city alone."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw9-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-2.webp",
                        "description": "Dr.Pradeep Chowbey, Dr.John Thanakumar, Srhi. Khader(Health Minister), Dr.Vikram"
                    },
                    {
                        "imageUrl": "/static/cw9-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-5.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-6.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-7.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-8.webp",
                        "description": "Dr. KR Narsimha Shetty(Director KID)"
                    },
                    {
                        "imageUrl": "/static/cw9-g-9.webp",
                        "description": "Iviting Dr. Mathias Fobi"
                    },
                    {
                        "imageUrl": "/static/cw9-g-10.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-11.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-12.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-13.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-14.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-15.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-16.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-17.webp",
                        "description": "Conference Sessions / Guest Lecture"
                    },
                    {
                        "imageUrl": "/static/cw9-g-18.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-19.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-20.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-21.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-22.webp",
                        "description": "Live Operative workshop Live transmission from Vikram Hospital to Hotel Marriott"
                    },
                    {
                        "imageUrl": "/static/cw9-g-23.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-24.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw9-g-25.webp",
                        "description": "National Professional Excellence Award"
                    },
                    {
                        "imageUrl": "/static/cw9-g-26.webp",
                        "description": "Lifetime Achievement Award to Dr.Tehemton Udwadia"
                    },
                    {
                        "imageUrl": "/static/cw9-g-27.webp",
                        "description": "National Professional Excellence Award"
                    },
                    {
                        "imageUrl": "/static/cw9-g-28.webp",
                        "description": "InternationalProfessional Excellence Award"
                    },
                    {
                        "imageUrl": "/static/cw9-g-29.webp",
                        "description": "Honouring Health Minister"
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 9,
        "Title": "HERNIA 2009",
        "MainImage": "/static/cw10-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw10-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:3rd, 4th, 5th, 6th Deccember Conference Venue: BGS Global Hospital",
                "text": "This was the first single theme international conference and workshop organised at B.G.S Global Hospitals, Bangalore. Dr.Ugahare , the surgeon who pioneered “Ugahare technique” for Extraperitoneal repair for Inguinal hernia was the Chief International faculty. National faculty included Dr H.G.Doctor, Founder President of Hernia Society of India, Dr. John Thanakumar and Dr V.Venkatesh from Coimbatore, Dr Rajesh Khullar from New Delhi, Dr.Deepraj Bhandarkar and Dr Prashanth Rao from Mumbai, Dr Subhash Agarwal from Raipur and Dr Lakshmi Kona from Hyderabad. Dr Ravindranath, Chairman and Managing Director of B.G.S.Global Hospitals was the Chief Patron for the conference, Dr M.Ramesh was the Organising Chairman and Dr.Tulip was the Organising Secretary. This conference included Preconference skill development courses on Endosuturing and Knotting, Inguinal and Ventral hernia courses on specially developed indigenous modules on BEST Endotrainers and Lectures on Hernia surgery from National and International faculty. The preconference course was attended by 220 delegates from all over the country. During the Live Operative Workshop, a total of 18 cases were demonstrated in a day. The cases included Laparoscopic TEP and TAPP repair for Inguinal hernias, Laparoscopic Preperitoneal repair for Umbilical Hernias and Laparoscopic IPOM and IPOM Plus repair for Umbilical, Incisional and Rare abdominal wall hernias. It was first time in National conference that “Ugahare Technique” an open pre-peritoneal mesh repair technique for inguinal hernia was demonstrated. The Live Operative workshop was attended by 350 delegates from all over the country."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw10-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-3.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-5.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-6.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-7.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-8.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-9.webp",
                        "description": "Dr.John Thanakumar honouring Dr. Ugahare"
                    },
                    {
                        "imageUrl": "/static/cw10-g-10.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-11.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-12.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-13.webp",
                        "description": "Specialised Inguinal hernia training module developed by BEST Institute & Research Centre"
                    },
                    {
                        "imageUrl": "/static/cw10-g-14.webp",
                        "description": "Dr. Ugahare & Dr. Prashanth Rao"
                    },
                    {
                        "imageUrl": "/static/cw10-g-15.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-16.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw10-g-17.webp",
                        "description": "Dr. Tulip Teaching Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw10-g-18.webp",
                        "description": "Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw10-g-19.webp",
                        "description": "Dr. Deepraj Bhandarkar Teaching Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw10-g-20.webp",
                        "description": "Dr.M.Ramesh Lecturing"
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 10,
        "Title": "BEST @50",
        "MainImage": "/static/cw11-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw11-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:18th, 19th, 20th October 2007 Conference Venue: NIMHANS, Operative Venue:A.V. Hospital, Agadi Hospital, Indira Gandhi Institute of Health Care",
                "text": "B.E.S.T Institute started conducting laparoscopic surgical skills courses in many major conferences. It gained national repute for conducting such courses and was requested to conduct these courses by both associations of laparoscopic surgery, AMASI and IAGES during their annual national conferences – in AIIMS, New Delhi and Jaipur respectively. Even to this day the skills course organized by the Institute during its conference “Best@50”, which was organized to commemorate the completion of 50 training courses in 2007, has remained the biggest ever, not being surpassed by any other course organized by any other organization or association. B.E.S.T. Institute has also been conducting surgical skills course for postgraduate students and inspired them to select the field of laparoscopy as a life-carrier."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw11-g-1.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw11-g-2.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw11-g-3.webp",
                        "description": "Stalls"
                    },
                    {
                        "imageUrl": "/static/cw11-g-4.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw11-g-5.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw11-g-6.webp",
                        "description": "Conference Auditorium"
                    },
                    {
                        "imageUrl": "/static/cw11-g-7.webp",
                        "description": "Dr.Narendra Panday(Guest of Honor), Dr.Nagaraj ,Director NIMHANS(Chief Guest), Dr. V.K. Athre(Scientific Advisor to Rakshana Mantri)"
                    },
                    {
                        "imageUrl": "/static/cw11-g-8.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw11-g-9.webp",
                        "description": "Presendital address by Dr. Aatre"
                    },
                    {
                        "imageUrl": "/static/cw11-g-10.webp",
                        "description": ""
                    },
                    {
                        "imageUrl": "/static/cw11-g-11.webp",
                        "description": "Dr.Narendra Panday(Guest of Honor), Dr.Nagaraj ,Director NIMHANS(Chief Guest), Dr. V.K. Athre(Scientific Advisor to Rakshana Mantri)"
                    },
                    {
                        "imageUrl": "/static/cw11-g-12.webp",
                        "description": "Honouring Dr. PM Chandrasekhara"
                    },
                    {
                        "imageUrl": "/static/cw11-g-13.webp",
                        "description": "Honouring Dr. Aashish Shah"
                    },
                    {
                        "imageUrl": "/static/cw11-g-14.webp",
                        "description": "Honouring Dr."
                    },
                    {
                        "imageUrl": "/static/cw11-g-15.webp",
                        "description": "Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw11-g-16.webp",
                        "description": "Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw11-g-17.webp",
                        "description": "Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw11-g-18.webp",
                        "description": "Laparoscopic Skills Training"
                    },
                    {
                        "imageUrl": "/static/cw11-g-19.webp",
                        "description": "Dr. Aatre Launching the Video Book on Laparoscopic Colecystectomy"
                    },
                    {
                        "imageUrl": "/static/cw11-g-20.webp",
                        "description": "Video Books launched by Dr. Narendra Pandey (Guest of Honor)"
                    },
                    {
                        "imageUrl": "/static/cw11-g-21.webp",
                        "description": "Dr. Dan Cottam(USA) with Dr.Sunil Sharma (USA) & Dr. Nishith Gagrani"
                    },
                    {
                        "imageUrl": "/static/cw11-g-22.webp",
                        "description": ""
                    }
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 11,
        "Title": "LAPAROSCOPIC SURGERY WORKSHOP",
        "MainImage": "/static/cw12-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw12-banner-1.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 22nd, May 2005 Venue: Kerudi Hospital & Research Centre, Bagalkot",
                "text": "B.E.S.T. Institute & Research Centre organized a live operative workshop in a small town in North Karnataka, where there was a need to develop newer technologies in surgery like laparoscopic surgery. Dr. Kerudi is a well known doctor in North Karnataka who has been doing a lot of advanced surgeries and procedures in his own hospital at Bagalkot."
            },
            {
                "Type": "BannerImage",
                "url": "/static/cw12-main.webp"
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "Being a very senior and popular surgeon of the northern part of Karnataka State, he initiated this activity and requested B.E.S.T. Institute to organise this event at his hospital. A live operative workshop was organized with free registration to ensure maximum number of surgeons would attend this event. Twelve surgeries were performed which included almost all the common types of laparoscopic surgeries that are performed by general surgeons and gynaecologists. Dr. M. Ramesh, Dr. Saraswathi and Dr. Tulip of B.E.S.T. Institute performed all the surgeries. Senior surgeons from different cities were asked to moderate the operative sessions with a two-way audio and video. This was the first major event of this type in northern Karnataka. It was a very well appreciated workshop which received accolades from one and all and has remained a memorable event even to this day. The faculty included Dr. John Thanakumar who was a pioneer of advanced laparoscopic surgery in India and Dr. Nagabhushan, an accomplished urologist from USA. The uniqueness of this conference was initiating a technology conference for the first time in the country for surgeons. Video streaming was done to 8 different cities for doctors to watch the conference live in their respective auditoriums in difference medical colleges and major hospitals. This is by far the first time video streaming technology was used in the country.More than 300 surgeons and gynaecologists registered as delegates for this pioneering conference and workshop at Bangalore city alone."
            }
        ]
    },
    {
        "id": 12,
        "Title": "INTERNATIONAL CONFERENCE IN HUMAN MACHINE INTERFACE",
        "MainImage": "/static/cw13-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw13-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 2004 Venue: J.N. Tata Auditorium, Indian Institute of Science",
                "text": "In 2004, the institute organized a unique Meet called “International Conference in Human Machine Interface” along with Massachusetts Institute of Technology, U.S.A., at J.N. Tata Auditorium, Indian Institute of Science, which had several international faculty and was attended by about 800 delegates. This happens to be the first ever such event in the country to bring doctors, engineers and scientists to collaborate with each other to develop newer technologies."
            }
        ]
    },
    {
        "id": 13,
        "Title": "PRE-CONFERENCE LAPAROSCOPIC HERNIA WORKSHOP AT THE 22ND ANNUAL CONFERENCE OF KSC-ASI / ASISOUTH ZONE",
        "MainImage": "/static/cw14-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw14-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date:26th February 2004 Venue: A.V. Hospital, Pai Vista Convention Centre Bangalore",
                "text": "The annual surgical state conference in 2004 was organized at Bangalore. There was a need to organize an operative workshop for one day which had to be elaborating on some latest techniques that all surgeons would be interested. The organizing committee unanimously chose B.E.S.T. Institute & Research Centre for this event. The institute organized the pre conference workshop during the 22nd Conference of KSC-ASI. A live operative workshop was organized at A.V. Hospital where all different types of laparoscopic hernia surgeries were demonstrated and transmitted to Pai Vista Convention Centre using fibreoptic cables. There were several national faculty including Dr. Praveen Bhatia from New Delhi and Dr. Surendra Ugale from Hyderabad. International faculty included Dr. Michael VandenBosche from U.K. More than 500 delegates participated in the workshop."
            }
        ]
    },
    {
        "id": 14,
        "Title": "6TH POSTGRADUATE COURSE IN ENDOCRINESURGERY & 4TH INTERNATIONAL WORKSHOP ONMINIMALLY INVASIVE ENDOCRINE SURGERY",
        "MainImage": "/static/cw15-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw15-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 14th October 2003 Venue: A.V. Hospital, Benagaluru",
                "text": "Dr. M. Ramesh, Director of B.E.S.T. Indtitiute& Research Centre, was invited to associate with SGPGI Lucknow. During the international workshop that was going on at Lucknow. Dr. Ramesh performed two laparoscopic adrenalectomies, one for phaeochromocytoma and another by retroperitoneoscopy at A.V. Hospital were transmitted to Lucknow and were also streamed to Cuttack with live interaction with surgeons in the other two nodes, using ISDN lines. This is the first ever telesurgery that took place in India."
            }
        ]
    },
    {
        "id": 15,
        "Title": "BREAKTHROUGH SURGICAL TECHNOLOGIES",
        "MainImage": "/static/cw16-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw16-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 21st& 22nd November 1999 Venue: Hotel Ashok and M.S. Ramaiah College Hospital, Bangalore.",
                "text": "This conference was organized to introduce several new technologies that have been developed to the elite doctors of our country belonging to the surgical community. It was a whole day conference organized at Hotel Ashok, which was the main 5-Star hotel of Bangalore city. Among the invited faculty were the most techno savvy doctors, engineers and scientists who were involved in the development, monitoring and assessment of several technologies used for surgery, from across the globe. The highlight was the presentations of Dr. Richard Satava. The next day was a full day of live operative workshop which was organized at the National Institute of Advanced Studies Auditorium. Live surgeries being performed at Ramaiah Medical College Hospital were transmitted to the Auditorium and there was a two way audio and video transmission to discuss about the laparoscopic surgeries that were performed. Several advanced laparoscopic surgeries were performed which included GI, general, gynaecological and urological surgeries. The faculty included Dr. John Thanakumar who was a pioneer of advanced laparoscopic surgery in India and Dr. Nagabhushan, an accomplished urologist from USA. The uniqueness of this conference was initiating a technology conference for the first time in the country for surgeons. Video streaming was done to 8 different cities for doctors to watch the conference live in their respective auditoriums in difference medical colleges and major hospitals. This is by far the first time video streaming technology was used in the country.More than 300 surgeons and gynaecologists registered as delegates for this pioneering conference and workshop at Bangalore city alone."
            }
        ]
    },
    {
        "id": 16,
        "Title": "NATIONAL CONFERENCE & WORKSHOP IN UPPERG.I.&PAEDIATRIC SURGERY",
        "MainImage": "/static/cw17-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw17-main.webp"
            },
            {
                "Type": "Text",
                "Header": "Date: 10th& 11th July 1999 Venue: Kempe Gowda Institute of Medical Sciences Hospital, Bangalore",
                "text": "This was the second thematic conference and workshop in advanced laparoscopic surgery that was organized by B.E.S.T. Institute & Research Centre in association with KIMS Hospital, Bangalore. The two other fields of advanced laparoscopic surgery that was fast evolving were in the fields of Upper GI surgery, mainly benign surgeries on the oesophagus and the stomach, as well as in Paediatric Surgery. Experts from all over the country were invited as faculty, who included Dr. PradeepChowbey from New Delhi, Dr. K. Ravindranath from Hyderabad, Dr. John Thanakumar and Dr. V. Venkatesh from Coimbatore, Dr. Krishna Rau and Dr. Ashok Sunderarajan from Chennai and Dr.Doriarajan from Madurai. The Institute also continued its ernest effort to update doctors about the latest technologies that were embracing surgery. Dr. MandayamSrinivasan, Director of Touch Lab at Massachusetts Institute of Technology and Dr. Sastry from Stanford University were invited to give Guest Lectures on Virtual Reality & Robotics at Hotel Windsor Manor during the conference. They were also honoured by B.E.S.T. Institute & Research Centre with a special Award of Professional Excellence. Two separate workshops with live surgical demonstrations of different types of Upper GI surgeries and paediatric surgeries were performed by the best known laparoscopic surgeons from across the country. The conference included several master videos, guest lectures and panel discussions in the two fields of surgery. More than 450 surgeons attended this unique thematic advanced laparoscopic surgery conference and workshop."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw17-g-1.webp",
                        "description": "Xime Hall at St. Martha’s Hospital – Conference Venue"
                    },
                    {
                        "imageUrl": "/static/cw17-g-2.webp",
                        "description": "Dr. R.S. K. Murhty, Chairman , BEST Institute, Dr. K.S. Shekar, President, Association of Surgeons of India, Dr. Shadaksharappa, Dr. Krishnamurthy Senior-most physician and surgeon of Karnataka"
                    },
                    {
                        "imageUrl": "/static/cw17-g-3.webp",
                        "description": "Prof. R.H..N. Shenoi, Former Chief Surgeon of Karnataka among the delegates"
                    },
                    {
                        "imageUrl": "/static/cw17-g-4.webp",
                        "description": "Delegates from across South India"
                    },
                    {
                        "imageUrl": "/static/cw17-g-5.webp",
                        "description": "Prof. Shenoi being honoured by Dr. Raghuram, HOD of Surgery at St. Martha’s Hospital"
                    },
                    {
                        "imageUrl": "/static/cw17-g-6.webp",
                        "description": "Dr. Surgendra Ugale from Hyderabad dedonstrating laparoscopic repair of Umbilical hernia"
                    },
                ],
                "description": ""
            }
        ]
    },
    {
        "id": 17,
        "Title": "NATIONAL CONFERENCE & WORKSHOP ON HERNIA",
        "MainImage": "/static/cw18-main.webp",
        "content": [
            {
                "Type": "BannerImage",
                "url": "/static/cw18-main.webp"
            },
            {
                "Type": "Text",
                "Header": "",
                "text": "BEST Institute was started with the intention of sharing my knowledge with other fellow surgeons. During this journey, many conferences and workshops have been conducted. Skills training is the highlight of this Institute."
            },
            {
                "Type": "Text",
                "Header": "Dates: 27th& 28th March 1999 Venue: St. Martha's Hospital, Bangalore",
                "text": "This was the first single theme conference organized in India. BEST Institute & Research Centre associated with St. Martha’s Hospital and introduced surgeons to the evolving science of Laparoscopic Hernia Surgery. This was a time when surgeons in the country were adaptlng to the practice of laparoscopic surgery. It was quite convincing to perform basic laparoscopic surgeries like diagnostic procedures, chlolecystectomy and appendicectomy. But there was a lot of skepticism about performing hernia repair using laparoscopic surgery. There were a handful of surgeons who had convincingly started performing laparoscopic hernia surgeries, but it was imminent to convey the message that laparoscopic hernia surgery is feasible though had a steep learning curve. Time had come to honestly evaluate how laparoscopic hernia surgery compared with traditional open hernia surgery in a large scientific forum."
            },
            {
                "Type": "Gallery",
                "images": [
                    {
                        "imageUrl": "/static/cw18-g-1.webp",
                        "description": "Xime Hall at St. Martha’s Hospital – Conference Venue"
                    },
                    {
                        "imageUrl": "/static/cw18-g-2.webp",
                        "description": "HIGHLIGHTS P A G E 2 Xime Hall at St. Martha’s Hospital – Conference Venue Dr. R.S. K. Murhty, Chairman , BEST Institute, Dr. K.S. Shekar, President, Association of Surgeons of India, Dr. Shadaksharappa, Dr. Krishnamurthy Senior-most physician and surgeon of Karnataka"
                    },
                    {
                        "imageUrl": "/static/cw18-g-3.webp",
                        "description": "Prof. R.H..N. Shenoi, Former Chief Surgeon of Karnataka among the delegates"
                    },
                    {
                        "imageUrl": "/static/cw18-g-4.webp",
                        "description": "Delegates from across South India"
                    },
                    {
                        "imageUrl": "/static/cw18-g-5.webp",
                        "description": "Prof. Shenoi being honoured by Dr. Raghuram, HOD of Surgery at St. Martha’s Hospital"
                    },
                    {
                        "imageUrl": "/static/cw18-g-6.webp",
                        "description": "Dr. Surgendra Ugale from Hyderabad dedonstrating laparoscopic repair of Umbilical hernia"
                    }
                ],
                "description": ""
            }
        ]
    }
]